import { Component, OnInit } from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-videogallery',
  templateUrl: './videogallery.component.html',
  styleUrls: ['./videogallery.component.scss']
})
export class VideogalleryComponent implements OnInit {

  constructor(private meta: Meta,
              private titles: Title) { }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI Gallery: Celebrating Moments of Excellence');
        this.meta.updateTag({
            name: 'description',
            content: `Browse the ARNI Gallery to explore snapshots of campus life, events, and achievements, capturing the vibrant spirit and success of our community.`
        });
    }

}
